import React from "react";
import { Container } from "reactstrap";
import { RouteComponentProps } from "react-router";
import { FeedbackCategory, FeedbackSortOption } from "../../../Feedback/Constants/feedbackEnums";
import FeedbackListContainer from "../../../Feedback/Components/Common/FeedbackList/FeedbackListContainer";

type TParams = {
  shortname: string;
};

const BUG_REPORT = [FeedbackCategory.BugReport];

const CompanyProfileBugReportsContainer: React.FC<RouteComponentProps<TParams>> = props => (
  <Container fluid>
    <FeedbackListContainer
      listId={`APP_COMPANY_PROFILE_ALL_BUG_REPORTS_LIST${props.match.params.shortname}`}
      sort={FeedbackSortOption.DateCreated}
      isAscending={false}
      reorderable
      shortname={props.match.params.shortname}
      fullscreen
      enableDownload
      selectedCategories={BUG_REPORT}
    />
  </Container>
);

export default CompanyProfileBugReportsContainer;
